module.exports = __webpack_public_path__ + "img/skip-start-fill.9f64c7b5.svg";